import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class IssueOfShares extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }
  get title() {
    return get(this, '_tytul.value', '');
  }
  get description() {
    return get(this, '_opis.value', '');
  }
  get filesHeader() {
    return get(this, '_naglowek_plikow.value', '');
  }
  get attachments() {
    return get(this, '_pliki.value', []);
  }
  get photo() {
    return get(this, '_zdjecie.value[0]', {});
  }
  get seo() {
    const seoModel = get(this, '_seo.value[0].model', {});
    if (!seoModel.title) {
      seoModel.title = this.title;
    }
    return seoModel;
  }
  get contactFormTitle() {
    return get(this, '_formularz_tytul.value', '');
  }
  get contactFormSubtitle() {
    return get(this, '_formularz_podtytul.value', '');
  }
  get contactFormPocessingAcceptance() {
    return get(this, '_formularz_zgoda_przetwarzanie.value', '');
  }
  get contactFormSendingAcceptance() {
    return get(this, '_formularz_zgoda_wysylanie.value', '');
  }
  get url() {
    return get(this, '_url.value', '');
  }

  get modalContent() {
    return get(this, '_modal_tresc.value', '');
  }

  get videoUrl() {
    return get(this, '_youtube_link.value', '');
  }

  get videoHeader() {
    return get(this, '_naglowek_video.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/IssueOfShares.model.js